<template>
  <v-dialog v-model="value" max-width="500px" persistent>
    <v-card>
      <v-card-title class="headline font-weight-thin">
        Create a New Service Area Category
      </v-card-title>
      <v-form v-model="valid" ref="form">
        <v-card-text>
          <v-text-field
            :rules="nameRules"
            clearable
            data-cy="categoryForm__categoryName"
            label="Service Area Category Name"
            required
            v-model="serviceAreaCategory.name"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close" outlined>Cancel</v-btn>
          <v-btn @click="save" :disabled="!valid" color="primary" data-cy="categoryForm__saveBtn">Save</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      nameRules: [name => !!name || "Name is required"],
      serviceAreaCategory: {},
      valid: true,
    };
  },
  methods: {
    close() {
      this.$emit("input", false);
      this.$refs.form.reset();
    },
    async save() {
      try {
        await this.createServiceAreaCategory(this.serviceAreaCategory);
      } catch (e) {
        console.error(e);
        this.createCategoryError();
      }
      this.close();
    },
    ...mapActions({
      createServiceAreaCategory: "admin/serviceAreaCategory/create",
    }),
  },
  notifications: {
    createCategoryError: {
      title: "Error!",
      message: "There was an error creating a new category.",
      type: "error",
    },
  },
  props: ["value"],
};
</script>
